/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { DropzoneArea } from 'material-ui-dropzone';
import { withTranslation } from 'react-i18next';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import '../RegistrationSetup/Registrationsetup.scss';
import { ToastContainer, toast } from 'react-toastify';
import ToastMessage from '../common/ToastMessage';
import 'react-toastify/dist/ReactToastify.css';
import { ClaimDetailsSVG } from '../../img/GlobalSVG';
import Header from '../../components/common/Header/Header';

class WhiteLabeling extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleWhiteListConfirmation =
      this.handleWhiteListConfirmation.bind(this);

    this.state = {
      show: false,
      showUpdate: false,
      files: [],
    };
  }
  handleChangeFileUpload(files) {
    this.setState({
      files: files,
    });
  }

  handleClose() {
    this.setState({ show: false, showUpdate: false });
  }

  handleShow() {
    this.setState({ show: true });
  }
  handleUpdate() {
    this.setState({ showUpdate: true });
  }
  handleWhiteListConfirmation() {
    this.setState({
      showConfirm: toast.success(
        <ToastMessage
          type="success"
          subTitle={'Branding has been modified successfully'}
        />,
      ),
      showUpdate: false,
    });
  }

  render() {
    const { backtoDashboard } = this.state;
    const { t } = this.props;
    if (backtoDashboard) {
      return <Navigate to="/admin/dashboard" push={true}></Navigate>;
    }

    return (
      <div>
        <Container fluid className="claims-details">
          <Header
            linkTo={'/admin/white-labeling'}
            header={t('admin.pages.branding.module')}
          />

          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Title & Logo</h3>
              <p>
                First step for theming which includes the title of the member
                portal and upload logos.
              </p>
            </Col>
            <Col className="setup-form">
              <div>
                <Form.Group controlId="formGroupTitle">
                  <Form.Label>Title</Form.Label>
                  <Form.Control type="text" placeholder="Vitory Health" />
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="formGroupClogo">
                  <Form.Label>Change Logo</Form.Label>
                  <img
                    src={require('../../img/A1MLogo_new.png')}
                    id="tick-img"
                    alt="LogoImage"
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  className="sav-btn"
                  onClick={this.handleShow}
                >
                  CHANGE
                </Button>
              </div>
            </Col>
          </Row>
          <Modal
            ref={(el) => {
              this.dialog = el;
            }}
            show={this.state.show}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Upolading Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DropzoneArea
                acceptedFiles={['image/*']}
                onChange={this.handleChangeFileUpload.bind(this)}
                showFileNames
                dropzoneText="Drag and Drop here"
                maxFileSize={250000}
                showAlerts={true}
                filesLimit={5}
              />
              <p>Accepted file types: SVG, PNG and JPG</p>
              <p>For best result maintain the size: 234px x 64px </p>
              <div className="model-footer-btn">
                <Button variant="secondary" onClick={this.handleClose}>
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={this.handleClose}
                  className="text-right pull-right"
                >
                  Change
                </Button>
              </div>
            </Modal.Body>
          </Modal>
          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Color Palette</h3>
              <p>
                The appearance of web portal and the mobile app across all
                devices.
              </p>
            </Col>
            <Col className="setup-form">
              <Row>
                <Col className="margin-right-30">
                  <div className="colorplate-img">
                    <img
                      src={require('../../img/colorplate.svg')}
                      id="color-img"
                      alt="ColorImage"
                    />
                    <Form.Check
                      type="radio"
                      aria-label="radio 1"
                      label="Default"
                    />
                  </div>
                </Col>
                <Col className="margin-right-30">
                  <div className="colorplate-img">
                    <img
                      src={require('../../img/colorplate.svg')}
                      id="color-img"
                      alt="ColorImage"
                    />
                    <Form.Check
                      type="radio"
                      aria-label="radio 1"
                      label="Azure"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className="margin-right-30">
                  <div className="colorplate-img">
                    <img
                      src={require('../../img/colorplate.svg')}
                      id="color-img"
                      alt="ColorImage"
                    />
                    <Form.Check
                      type="radio"
                      aria-label="radio 1"
                      label="Regal Blue"
                    />
                  </div>
                </Col>
                <Col className="margin-right-30">
                  <div className="colorplate-img">
                    <img
                      src={require('../../img/colorplate.svg')}
                      id="color-img"
                      alt="ColorImage"
                    />
                    <Form.Check
                      type="radio"
                      aria-label="radio 1"
                      label="Cyprus"
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className="alredy-member">
                    Feeling Creative? Create a{' '}
                    <Link to="/admin/workinprogress">custom theme.</Link>
                  </p>
                  <Form.Group id="formGridCheckboxdarkk">
                    <Form.Label className="dark-Mode" for="dark-mode1">
                      Enable dark mode
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      id="dark-mode"
                      label="Allow users to switch between light and dark mode in the portal"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div>
                <p>Mode preview</p>
                <div className="standerted-theme">
                  <Row>
                    <Col>
                      <h3>
                        LOGO
                        <br /> <span>PLACEHOLDER</span>
                      </h3>
                    </Col>
                    <Col>
                      <ul>
                        <li>
                          <img
                            src={require('../../img/Identity.png')}
                            id=""
                            alt="LogoImage"
                          />
                        </li>
                        <li>Hi, Dennis</li>
                      </ul>
                    </Col>
                  </Row>
                  <p>Standard Theme</p>
                </div>
                <div className="dark-theme">
                  <Row>
                    <Col>
                      <h3>
                        LOGO
                        <br /> <span>PLACEHOLDER</span>
                      </h3>
                    </Col>
                    <Col>
                      <ul>
                        <li>
                          <img
                            src={require('../../img/Identity.png')}
                            id=""
                            alt="LogoImage"
                          />
                        </li>
                        <li>Hi, Dennis</li>
                      </ul>
                    </Col>
                  </Row>
                  <p>dark Theme</p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="Payment-details whitelist">
            <Col className="padding-0">
              <h3>Fonts</h3>
              <p>
                The fonts of web portal and the mobile app across all devices.
              </p>
            </Col>
            <Col className="setup-form">
              <div>
                <Form.Group controlId="formGroupHead">
                  <Form.Label>Default fonts for Headings</Form.Label>
                  <Form.Control as="select">
                    <option>Open Sans</option>
                  </Form.Control>
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="formGroupPara">
                  <Form.Label>
                    Default fonts for Paragraphs and other texts
                  </Form.Label>
                  <Form.Control as="select">
                    <option>Open Sans</option>
                  </Form.Control>
                </Form.Group>
              </div>
            </Col>
          </Row>

          <Row className="Payment-details password-policy">
            <Col className="float-right text-right">
              <Button
                variant="primary"
                className="sav-btn"
                onClick={this.handleUpdate}
              >
                Update
              </Button>
            </Col>
          </Row>

          <Modal
            ref={(el) => {
              this.dialog = el;
            }}
            show={this.state.showUpdate}
            onHide={this.handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
            <Modal.Body className="update-whitelapling">
              <p>Theme would be modied on:</p>
              <h4>
                <a href="">Commercial LOB</a>
              </h4>
              <h4>
                <a href="">Vitori Health</a>
              </h4>
              <h4>
                <a href="">All Locations</a>
              </h4>
              <p>Do you want to proceed?</p>

              <div className="model-footer-btn">
                <Button variant="secondary" onClick={this.handleClose}>
                  Close
                </Button>
                <Button
                  variant="primary"
                  onClick={this.handleWhiteListConfirmation}
                  className="text-right pull-right"
                >
                  CONFIRM
                </Button>
              </div>
            </Modal.Body>
            {/*<Modal.Footer>
                <Button onClick={this.handleClose}>Cancel</Button>
                <Button onClick={this.handleWhiteListConfirmation}>CONFIRM</Button>
              </Modal.Footer> */}
          </Modal>
          <div className="toastify">
            <ToastContainer
              position="top-center"
              autoClose={false}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </Container>
      </div>
    );
  }
}
export default withTranslation()(WhiteLabeling);
